<template>
  <v-col class="Day-schedule">
    <v-chip
      class="Row-label"
      color="#F2F4F6"
      :class="schedule.active && 'Row-label--active'"
      @click="schedule.active = !schedule.active"
      data-e2e="DayScheduleToggleActivity"
      label
      >{{ $t(`dayOfWeek.${schedule.key.toUpperCase()}`) | capitalize }}</v-chip
    >
    <v-select
      append-icon="mdi-clock-outline"
      class="Row-start"
      item-text="display"
      :background-color="setColor"
      :disabled="!schedule.active"
      :items="openingHours"
      :value="schedule.start"
      data-e2e="DayScheduleOpeningHour"
      @input="checkEndHour"
    />
    <v-select
      append-icon="mdi-clock-outline"
      class="Row-end"
      item-text="display"
      v-model="schedule.end"
      :background-color="setColor"
      :disabled="!schedule.active"
      :items="closingHours"
      data-e2e="DayScheduleClosingHour"
    />
    <v-select
      class="Row-end DaySchedule--small"
      v-model="schedule.maxSlot"
      :background-color="setColor"
      :disabled="!schedule.active"
      :items="slotChoices"
      data-e2e="DayScheduleClosingHour"
    />
  </v-col>
</template>

<script>
export default {
  name: 'DaySchedule',
  props: {
    schedule: {
      type: Object,
      required: true
    },
    availableHours: {
      type: Array,
      required: true
    },
    maxSlot: {
      type: Number,
      default: 5
    }
  },
  computed: {
    setColor() {
      const activeColor = this.$site === this.$const.sites.galileo ? '#059D6D' : 'rgba(61, 66, 77, 0.9)'
      return !this.schedule.active ? '#f2f4f6' : activeColor
    },
    openingHours() {
      return this.availableHours.slice(0, this.availableHours.length - 1)
    },
    closingHours() {
      return this.availableHours.filter(hour => hour.value > this.schedule.start)
    },
    slotChoices() {
      const res = []
      for (let i = 1; i <= this.maxSlot; i++) {
        res.push(i)
      }
      return res
    }
  },
  methods: {
    checkEndHour(hourStart) {
      if (hourStart >= this.schedule.end) {
        let indexStart = this.availableHours.findIndex(hour => hour.value === hourStart)
        this.schedule.end = this.availableHours[indexStart + 1].value
      }
      this.schedule.start = hourStart
    }
  },
  filters: {
    capitalize(label) {
      if (typeof label !== 'string') return ''
      return label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()
    }
  }
}
</script>

<style scoped lang="scss">
.Day-schedule {
  min-width: 125px;
  max-width: 250px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  * {
    margin: 5px 0;
  }
  .v-input {
    font-size: 0.95rem;
  }
  .Row-start,
  .Row-end {
    align-items: center;
    display: flex;
    height: 40px;
    min-width: 60px;
    padding-top: 10px;
  }
  .Row-label {
    height: 40px;
    justify-content: center;
    align-items: center;
    transition: 0.35s ease-out;
    width: 100%;
    margin-bottom: 30px;
    &--active {
      background-color: var(--v-secondary-base) !important;
      color: #fff;
    }
  }
}
</style>

<style lang="scss">
.Day-schedule {
  .v-input__slot {
    padding: 0 7px;
    border-radius: 5px;
    &::before {
      border: none !important;
    }
  }
  .Row-label--active ~ .v-input {
    * {
      color: #fff !important;
    }
  }
}

.DaySchedule--small {
  width: 50px;
  margin-left: 65px !important;
}
</style>

<style lang="scss">
.App-galileo .Day-schedule {
  .Row-label {
    &--active {
      background-color: #059d6d !important;
    }
  }
}
</style>
